import { SUBSCRIPTION_PLANS } from '@src/constants';

export const isEnterprise = (planType: string): boolean => {
  return ['enterprise', 'ENTERPRISE'].includes(planType);
};

export const isCandidatePlan = (planType: string): boolean => {
  return ['candidate-plan-190407', 'CANDIDATE_PLAN_190407'].includes(planType);
};

export const isSubscriptionUnlimited = (planType: string): boolean => {
  return ['subscription_unlimited', SUBSCRIPTION_PLANS.UNLIMITED].includes(planType);
};

export const isSubscriptionBasic = (planType: string): boolean => {
  return ['subscription_basic', SUBSCRIPTION_PLANS.BASIC].includes(planType);
};

export const isSubscriptionStarter = (planType: string): boolean => {
  return ['subscription_starter', SUBSCRIPTION_PLANS.STARTER].includes(planType);
};

export const isSubscriptionLowBase = (planType: string): boolean => {
  return ['subscription-low-base', SUBSCRIPTION_PLANS.SUBSCRIPTION_LOW_BASE].includes(planType);
};

export const isSubscriptionHighBase = (planType: string): boolean => {
  return ['subscription-high-base', SUBSCRIPTION_PLANS.SUBSCRIPTION_HIGH_BASE].includes(planType);
};

export const isSlotBasedSubscription = (planType: string): boolean => {
  return isSubscriptionLowBase(planType) || isSubscriptionHighBase(planType);
};

export const isSubscriptionLimitedLowBase = (planType: string): boolean => {
  return ['subscription-low-base', SUBSCRIPTION_PLANS.SUBSCRIPTION_LIMITED_LOW_BASE].includes(planType);
};

export const isSubscriptionLimitedHighBase = (planType: string): boolean => {
  return ['subscription-high-base', SUBSCRIPTION_PLANS.SUBSCRIPTION_LIMITED_HIGH_BASE].includes(planType);
};

export const isLimitedSlotSubscription = (planType: string): boolean => {
  return isSubscriptionLimitedLowBase(planType) || isSubscriptionLimitedHighBase(planType);
};
